import { pick } from 'lodash'
import { FieldGroup } from 'modules/modular/FieldGroup'
import { Input } from 'modules/modular/Input'
import { useMemo, useState } from 'react'
import { Button, Modal, Table } from 'react-bootstrap'
import { formatCurrency } from 'utils/FormatNumber'

const initialSelected = { index: -1, value: null }
const initialValues = {
    detalle: '',
    importe: '',
}

export default function SolicitudGastos({ gastos, setGastos }) {
    const [selected, setSelected] = useState(initialSelected)
    const [values, setValues] = useState(initialValues)
    const [showForm, setShowForm] = useState(false)

    const total = useMemo(() => gastos.reduce((carry, el) => carry + parseFloat(el.importe), 0), [gastos])

    const add = () => {
        setGastos((prev) => [...prev, values])
        setShowForm(false)
    }
    const update = () => {
        if (selected.value) {
            setGastos((prev) => prev.map((el, i) => (i === selected.index ? values : el)))
        }
        setShowForm(false)
    }
    const remove = (index) => {
        setGastos((prev) => prev.filter((_, i) => i !== index))
    }

    const handleChange = (e) => {
        setValues((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }
    const handleAction = (action, data = null) => {
        if (action === 'create' || action === 'update') {
            setSelected(data ?? initialSelected)
            setValues(data ? pick(data.value, ['detalle', 'importe']) : initialValues)
            setShowForm(true)
        }
    }
    const clearSelected = () => {
        setSelected(initialSelected)
        setValues(initialValues)
    }

    return (
        <div>
            <div className='d-flex align-items-center mb-3'>
                <span className='fs-5'>Viáticos, Pasajes y Otros</span>
                <Button variant='blue' className='ms-auto' onClick={() => handleAction('create')}>
                    <span className='bi-plus-lg' /> Agregar detalle
                </Button>
            </div>
            <Table bordered>
                <thead>
                    <tr>
                        <th className='text-center w-75'>Detalle</th>
                        <th className='text-center'>Importe Referencial Bs.</th>
                        <th className='text-center' style={{ width: '6rem' }}>
                            Opciones
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {gastos.map((gasto, index) => (
                        <tr key={index}>
                            <td>{gasto.detalle}</td>
                            <td className='text-end'>{formatCurrency(gasto.importe)}</td>
                            <td className='text-nowrap text-center'>
                                <Button size='sm' onClick={() => handleAction('update', { index, value: gasto })}>
                                    <span className='bi-pencil' />
                                </Button>
                                <Button size='sm' variant='danger' className='ms-2' onClick={() => remove(index)}>
                                    <span className='bi-trash' />
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr>
                        <th className='text-end'>Total Gastos</th>
                        <th className='text-end'>{formatCurrency(total)}</th>
                        <th></th>
                    </tr>
                </tfoot>
            </Table>
            <Modal show={showForm} onExited={clearSelected} centered dialogClassName='w-25rem'>
                <Modal.Header className='py-1'>
                    <Modal.Title>{selected.value ? 'Modificar' : 'Agregar'} Detalle</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FieldGroup label='Detalle'>
                        <Input name='detalle' value={values.detalle} onChange={handleChange} as='textarea' rows={3} />
                    </FieldGroup>
                    <FieldGroup label='Importe Referencial (Bs)'>
                        <Input
                            type='currency'
                            name='importe'
                            value={values.importe}
                            onChange={handleChange}
                            className='text-end'
                        />
                    </FieldGroup>
                </Modal.Body>
                <Modal.Footer className='py-2'>
                    <Button variant='outline-blue' onClick={() => setShowForm(false)}>
                        <span className='bi-x-lg' /> Cancelar
                    </Button>
                    <Button variant='blue' onClick={selected.value ? update : add}>
                        <span className='bi-floppy' /> Guardar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}
